import Endpoints from 'constants/Endpoints';
import {RestRequestDELETE, RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import {clearResource, setResource, setSaveStatusError} from 'redux/actions'
import reduxStore from 'redux/store'
import applySearchParams from "../libs/applySearchParams";
import Tr from "../translations/Translations";

const AGREEMENTS_RESOURCE_ID = 'agreementsList';
const AGREEMENTS_AVAILABLE_RESOURCE_ID = 'agreementsAvailableList';
const AGREEMENTS_AVAILABLE_ORGANIZATIONS_RESOURCE_ID = 'agreementsAvailableOrganizationsList';

const getAgreementsList = async (demandId, pagination, searchData) => {
    try {
        let params = {
            ...pagination
        }
        params = applySearchParams(searchData, params);
        const resp = await RestRequestGET(Endpoints.AGREEMENTS_CREATED(demandId), {params});
        reduxStore.dispatch(setResource(AGREEMENTS_RESOURCE_ID, resp));
    } catch (error) {
    }
};
const getAgreementsAvailableList = async (demandId, pagination, searchData) => {
    try {
        let params = {
            ...pagination
        }
        params = applySearchParams(searchData, params);

        const resp = await RestRequestGET(Endpoints.AGREEMENTS_AVAILABLE(demandId), {params});
        reduxStore.dispatch(setResource(AGREEMENTS_AVAILABLE_RESOURCE_ID, resp));
    } catch (error) {
    }
};

const getAgreementsAvailableOrganizationsList = async (demandId) => {
    try {
        const resp = await RestRequestGET(Endpoints.AGREEMENTS_AVAILABLE_ORGANIZATIONS(demandId));
        reduxStore.dispatch(setResource(AGREEMENTS_AVAILABLE_ORGANIZATIONS_RESOURCE_ID, resp));
    } catch (error) {
    }
};

const createNoAgreements = async (demandId, positionIds) => {
    const resp = await RestRequestPOST(Endpoints.AGREEMENTS_CREATE_NO_AGREEMENT(demandId), {items: positionIds});
    if(!resp.success) {
        reduxStore.dispatch(setSaveStatusError(Tr('bad_request_error')));
    }
    return resp;
};

const deleteAgreement = async (demandId, objId, objType) => {
    const resp = await RestRequestDELETE(objType === 'agreement' ? Endpoints.AGREEMENTS_DELETE_AGR(demandId, objId) : Endpoints.AGREEMENTS_DELETE(demandId, objId));
    if(!resp.success) {
        reduxStore.dispatch(setSaveStatusError(Tr('bad_request_error')));
    }
    return resp;
};

const createAgreements = async (demandId, positionIds, orgForAgreement, oneAgreement) => {
    const resp = await RestRequestPOST(Endpoints.AGREEMENTS_CREATE_AGREEMENT(demandId), {positionIds, oneAgreement, orgForAgreement});
    if(!resp.success) {
        reduxStore.dispatch(setSaveStatusError(Tr('bad_request_error')));
    }
    return resp;
};

const validate = async (id) => {
    return RestRequestGET(Endpoints.AGREEMENTS_VALIDATE(id));
}

const clearResources = (resource) => {
    reduxStore.dispatch(clearResource(resource));
};

export default {
    getAgreementsList,
    getAgreementsAvailableList,
    getAgreementsAvailableOrganizationsList,
    createAgreements,
    createNoAgreements,
    deleteAgreement,
    validate,
    clearResources,
    AGREEMENTS_RESOURCE_ID,
    AGREEMENTS_AVAILABLE_RESOURCE_ID,
    AGREEMENTS_AVAILABLE_ORGANIZATIONS_RESOURCE_ID
}